<template>
    <div :class="{'page-wrapper' : type == 'donate'}">
        <div class="page-bg dark-bg"></div>
        <div class="page-content"
            v-if="isAccountLoaded">
            <div v-if="isLoaded">
                <TopBarDetail
                    type="detail"
                    @clickBack="clickBack()" />
                <DonateLayout
                    v-if="type == 'donate'"
                    :lbl="lbl"
                    :localeCode="localeCode"
                    :isLogin="isLogin"
                    :userPoint="point"
                    :type="type"
                    :detailController="detailController"
                    :modalController="modalController"
                    :redeemController="redeemController" />
                <DefaultLayout
                    v-else
                    :lbl="lbl"
                    :localeCode="localeCode"
                    :isLogin="isLogin"
                    :userPoint="point"
                    :detailController="detailController"
                    :modalController="modalController"
                    :redeemController="redeemController" />
            </div>

            <ModalMaster :controller="modalController" />
        </div>
    </div>
</template>
<script>
import Vue from 'vue';
//config
import Config from '@/config/ConfigManager.js';
//core
import { CampaignConfigBuilder } from "@/core/Campaign/model/CampaignConfigModel.js";
//helper
import CacheHelper from "@/helper/CacheHelper.js";
//mixin
import AccountMixin from '@/mixin/AccountMixin.js';
import ErrorApiMixin from '@/mixin/ErrorApiMixin.js';
import LocaleMixin from '@/mixin/LocaleMixin.js';
import ModalMixin from '@/mixin/ModalMixin.js';
//component
import DefaultLayout from "../component/layout/Default.vue";
import DonateLayout from "../component/layout/Donate.vue"
import TopBarDetail from '@/components/Layout/TopBarPage/TopBarDetail.vue';
//controller
import { DetailController } from '../controller/DetailController.js';
import { RedeemController } from '../controller/RedeemController.js';

export default {
    name: "Campaign",
    mixins: [AccountMixin, ErrorApiMixin, LocaleMixin, ModalMixin],
    components: {
        DefaultLayout,
        TopBarDetail,
        DonateLayout
    },
    data: function() {
        return {
            isLoaded: false,
            //controller
            detailController: new DetailController(),
            redeemController: new RedeemController(),

            type: '',
        };
    },
    created: function() {
        this.modalController.loadingModal.show();

        this.initialIsFromLanding();
        this.initialRedeemModal(); //ModalMixin
    },
    methods: {
        //mixin initial
        accountInitiated: function () {
            this.initialCampaign();
        },
        setType: function (type) {
            switch (type) {
                case Vue.CampaignType.Donate:
                    this.type = 'donate'
                    break;

                default:
                    break;
            }

        },
        //event
        clickBack: function () {
            var cache = new CacheHelper('session');
            var cacheCookie = new CacheHelper();
            let registerSurvey = cacheCookie.getCache('isRegisterSurvey');

            if (cache.getCache('isFromBDM') || registerSurvey == 'register_survey') {
                cache.removeCache('isFromBDM');
                cacheCookie.removeCache('isRegisterSurvey');
                this.$router.push('/');
            } else {
                this.$router.go(-1);
            }
            
            console.log('back');
        },
        //initial
        initialCampaign: function () {
            var campaignId = this.$route.params.campaignId;
            this.campaignConfig = new CampaignConfigBuilder()
                .setCampaignId(campaignId)
                .create();

            this.detailController.initial(this.campaignConfig, this.modalController);

            this.initialDetailControllerCallback();
        },
        initialIsFromLanding: function () {
            var cacheHelper = new CacheHelper(Config.getCacheType());
            if (cacheHelper.getCache('isfromlanding') != undefined) {
                var landingCache = cacheHelper.getCache('isfromlanding');
                
                console.log('ca',landingCache);
                var backAmount;
                if (landingCache == 'wodd' || landingCache == 'datapackageinternet') {
                    backAmount = -1;
                    history.go(backAmount);
                } else if (landingCache == 'register_survey') {
                    window.location.replace('/home')
                    cacheHelper.removeCache('isRegisterSurvey');
                } else { 
                    backAmount = (landingCache == 'interface') ? -3 : -2;
                    history.go(backAmount);
                }
                cacheHelper.removeCache('isfromlanding');
            }
        },
        //detail controller callback
        initialDetailControllerCallback: function () {
            this.detailController.onApiSuccess(data => {
                switch (data.tag) {
                    case 'get-campaign':
                        this.redeemController.initial(this.detailController.campaign, this.modalController);
                        this.setType(this.detailController.type)
                        this.isLoaded = true;
                        break;
                    default:
                        this.isLoaded = true;
                        break;
                }
            });

            this.detailController.onApiError(data => {
                switch (data.tag) {
                    case 'get-campaign':
                        this.errorApi(data.err);
                        break;
                    default:
                        this.errorApi(data.err);
                        break;
                }
            });

            this.redeemController.onRedirect(data => {
                console.log(data);
                switch (data.type) {
                    case 'free-delivery':
                        this.$router.push('/rewards');
                        break;
                    default:
                        break;
                }
            });

            this.redeemController.onRedeemSuccess(data => {
                if(data){
                    console.log('success', data);
                    this.getUserLastestPoint();
                }
            });
        },
        //redeem controller callback
        initialRedeemControllerCallback: function () {
            this.redeemController.onRedeemSuccess(data => {
                switch (data.tag) {
                    case 'redeem':
                        break;
                    case 'add-cart':
                        break;
                    default:
                        break;
                }
            });

            this.redeemController.onErrorApi(data => {
                switch (data.tag) {
                    case 'redeem':
                        this.errorApi(data.err);
                        break;
                    case 'add-cart':
                        this.errorApi(data.err);
                        break;
                    default:
                        this.errorApi(data.err);
                        break;
                }
            });

        }
    }
}
</script>

